import React from 'react';
import styled from 'styled-components';
import chevronDown from './assets/ChevronDown.svg';
import {components} from 'react-select';

const Chevron = styled.div`
    background: transparent url(${chevronDown}) no-repeat right 1px center;
    background-size: 24px;
    width: 24px;
    height: 16px;
`;

export const DropdownIndicator = (props) => {
    return components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <Chevron/>
        </components.DropdownIndicator>
    );
};
